import { Model, Store } from 'store/Base';
import { observable } from 'mobx';
import { Contact, ContactStore } from './Contact';
import { Team } from './Team';
import { ContractStore } from './Contract';


export class Company extends Model {
    static backendResourceName = 'company';
    static omitFields = ['createdAt']

    @observable id = null;
    @observable name = '';
    @observable shortName = null;

    @observable createdAt = '';

    @observable qaEmail = '';

    @observable communicationRhythm = '';

    @observable invoiceAgreement = '';

    @observable reportingAgreement = '';

    @observable mainContact = this.relation(Contact);
    @observable responsible = this.relation(Contact);
    @observable responsibleTeam = this.relation(Team);
    @observable contracts = this.relation(ContractStore);
    @observable contacts = this.relation(ContactStore);
}

export class CompanyStore extends Store {
    Model = Company;
    static backendResourceName = 'company';
}
